<script setup lang="ts">
  import { useStepWizard as defaultUseStepWizard } from "@/lib/useStepWizard"
  import { inject } from "vue"
  import Button from "@/components/ui/button/Button.vue"
  import { StepWizardProgressCard } from "@/components/ui/step-wizard"

  const useStepWizard = inject("useStepWizard", defaultUseStepWizard)

  const { goNext } = useStepWizard()

  const onSubmit = async () => {
    goNext()
  }
</script>

<template>
  <form novalidate @submit.prevent="onSubmit">
    <StepWizardProgressCard title="Choose a plan">
      <template #next_button>
        <Button variant="tonal" type="submit" size="md"> Select Tariff </Button>
      </template>
    </StepWizardProgressCard>
  </form>
</template>
